import { Icon } from 'assets/index'
import { useContext, useEffect, useRef, useState } from 'react'
import { Form } from '@unform/web'
import {
  SelectCard,
  UploadImg2,
  ButtonNext,
  Path,
  MaskedInput2,
  Select2,
  Toggle,
} from 'components/index'
import { UserContext } from 'context'
import * as Yup from 'yup'
import { useStorage } from 'hooks'
import useFetch from 'hooks/useFetch'
import { clearString } from 'helper/utils'
import { schemaNewGestor, comissoes, levels, emailRegex } from './factory'
import { Container, Column, Row, ErrorText, ErrorContainer } from './style'

interface ValidationErrors {
  [key: string]: string
}

export default function NovoColaborador() {
  const { data, setData, setPage } = useContext(UserContext)
  const formRef = useRef<HTMLFormElement | any>(null)
  const [comissions, setComissions] = useState<any[]>([])
  const [levelError, setLevelError] = useState<any>(false)
  const [picError, setPicError] = useState<any>(false)
  const [gestSpec] = useStorage('GestSpec')
  const [gestores] = useStorage('Gestores')
  const [toggleForm, setToggleForm] = useState<string>('pf')
  const inputErrorInitialState = {
    cpf: '',
    email: '',
    cell: '',
  }
  const loadingInputInitialState = {
    cpf: false,
    email: false,
    cell: false,
  }
  const [inputLoading, setInputLoading] = useState(loadingInputInitialState)
  const [inputError, setInputError] = useState(inputErrorInitialState)
  const toggleOptionList = [
    ['Pessoa Física', 'pf'],
    ['Pessoa Jurídica', 'pj'],
  ]
  const api = useFetch()

  useEffect(() => {
    formRef.current.setErrors({})
    setData({})
    formRef.current.reset()
    // Formulário limpado não funciona
  }, [toggleForm])
  // Limpa os erros do formulário quando o tipo de pessoa sendo registrada muda

  const isRegisteringPF = toggleForm === 'pf'
  // Boleano que define as mudanças no formulario de acordo com o tipo de pessoa sendo registrada

  const formatedData = (formData: any) => {
    const filteredData = formData
    if (isRegisteringPF) {
      const { nickname, ...rest } = filteredData
      // Remove o campo nickname do objeto
      return {
        ...rest,
      }
    }
    const { ...rest } = filteredData
    return {
      ...rest,
    }
  } // Formata os dados de acordo com o tipo de pessoa sendo registrada

  const handleSubmit = async () => {
    if (inputError.cpf || inputError.email || inputError.cell) return
    setData(formatedData(data))
    try {
      // Remove all previous errors
      formRef.current.setErrors({})
      setPicError(false)
      setLevelError(false)
      setInputError(inputErrorInitialState)

      await schemaNewGestor(
        data.level === `[0, 0, 1, 0, 0, 0, 0, 0, 0]`,
        isRegisteringPF
      ).validate(data, { abortEarly: false })

      setPage(1)
    } catch (err) {
      console.error(err)
      const validationErrors: ValidationErrors = {}
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path] = error.message
          }
        })

        formRef.current.setErrors(validationErrors)
        setPicError(validationErrors.profilePic)
        setLevelError(validationErrors.level)
      }
    }
  }

  useEffect(() => {
    setData((oldValue: any) => ({
      ...oldValue,
      comission: comissions,
    }))
  }, [comissions])

  useEffect(() => {
    // Limpa o erro de profilePic quando houver um valor válido
    if (data.profilePic) {
      setPicError(null)
    }
  }, [data.profilePic])

  useEffect(() => {
    // Limpa o erro de level quando houver um valor válido
    if (data.level) {
      setLevelError(null)
    }
  }, [data.level])

  const handleInputRequest = (
    key: string,
    inputValue: string,
    type: string | null
  ) => {
    // Inicia o loading para o campo específico
    setInputLoading((prevState) => ({
      ...prevState,
      [key]: true,
    }))

    // Define o endpoint com base no tipo de validação
    const cleanInput =
      type === null ? clearString(inputValue).trim() : inputValue.trim()

    const endpoint =
      type !== null
        ? `/gestor/gestor-account/${cleanInput}?type=${type}`
        : `/gestor/gestor-account/${cleanInput}`
    // Executa a chamada da API
    api.fetch('get', null, endpoint).then((res) => {
      // Para o loading
      setInputLoading((prevState) => ({
        ...prevState,
        [key]: false, // Atualiza o campo específico para `false`
      }))

      // Atualiza o erro com base na resposta da API
      setInputError((prevState) => ({
        ...prevState,
        [key]: !res.errors ? '' : `${res.errors.message}`,
      }))
    })
  } // Verifica se o campo prenchido ja existe no banco de dados

  return (
    <Container>
      <Path className="path">
        <span className="path">
          {'Gestão de colaboradores > Novo Colaborador'}
        </span>
      </Path>

      <Form ref={formRef} onSubmit={() => console.log('submit')}>
        <div>
          <h1 className="new-colaborator-title">Novo Colaborador</h1>
          <div className="togle-container">
            <Toggle
              options={toggleOptionList}
              toggle={toggleForm}
              setToggle={setToggleForm}
            />
          </div>
          <div className="new-colaborator-container">
            {!isRegisteringPF && (
              <MaskedInput2
                large
                hasAsterisk
                maxLength={64}
                dataTestId="fantasy-name-input"
                type="text"
                handleChange={(e: any) => {
                  setData((oldValue: any) => ({
                    ...oldValue,
                    nickname: e.target.value,
                  }))
                }}
                placeholder="Nome Fantasia"
                name="nickname"
                defaultValue={data?.nickname}
              />
            )}

            <MaskedInput2
              large
              hasAsterisk
              maxLength={64}
              dataTestId="name-input"
              type="text"
              handleChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  name: e.target.value,
                }))
              }}
              placeholder={
                isRegisteringPF ? 'Nome do colaborador' : 'Razão social'
              }
              name="name"
              defaultValue={data?.name}
            />

            <MaskedInput2
              large
              hasAsterisk
              dataTestId="document-input"
              type={isRegisteringPF ? 'cpf' : 'cnpj'}
              loading={inputLoading.cpf}
              onBlur={async () => {
                if (data?.document?.length === 14) {
                  handleInputRequest('cpf', data.document, null)
                } else {
                  setInputError((prevState: any) => ({
                    ...prevState,
                    cpf: '',
                  }))
                }
              }}
              customError={inputError.cpf}
              handleChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  document: e.target.value,
                }))
              }}
              placeholder={isRegisteringPF ? 'CPF' : 'CNPJ'}
              name="document"
              defaultValue={data?.document}
            />
            <MaskedInput2
              large
              hasAsterisk
              dataTestId="email-input"
              type="text"
              maxLength={64}
              loading={inputLoading.email}
              onBlur={async () => {
                const emailIsvalid = emailRegex.test(data.email.trim())
                if (emailIsvalid) {
                  handleInputRequest('email', data.email, 'email')
                } else {
                  setInputError((prevState: any) => ({
                    ...prevState,
                    email: '',
                  }))
                }
              }}
              customError={inputError.email}
              handleChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  email: e.target.value,
                }))
              }}
              placeholder="E-mail"
              name="email"
              defaultValue={data?.email}
            />
            <MaskedInput2
              large
              hasAsterisk
              dataTestId="cellphone-input"
              type="cell"
              loading={inputLoading.cell}
              onBlur={async () => {
                if (data?.cellphone?.length === 15) {
                  handleInputRequest('cell', data.cellphone, 'cell')
                } else {
                  setInputError((prevState: any) => ({
                    ...prevState,
                    cell: '',
                  }))
                }
              }}
              customError={inputError.cell}
              handleChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  cellphone: e.target.value,
                }))
              }}
              placeholder="Número de celular"
              name="cellphone"
              defaultValue={data?.cellphone}
            />
            <Column>
              <UploadImg2
                error={picError}
                name="profilePic"
                onChangeFile={(file) => {
                  setData((oldValue: any) => ({
                    ...oldValue,
                    profilePic: file,
                  }))
                }}
              >
                {data?.profilePic?.name || 'Upload de foto'}
              </UploadImg2>

              <ErrorText error={picError} data-testid="picture-error">
                <img
                  className="img-error"
                  src={Icon('alert_circle.svg')}
                  alt="error icon"
                />
                {picError}
              </ErrorText>
            </Column>
          </div>
        </div>
        {/* Comissionamento
        <div>
          <div className="new-colaborator-subtitle">
            <img
              className="new-colaborator-subtitle-img"
              src={Icon('trophy.svg')}
              alt="subtitle icon"
            />
            <h4>Programa de comissionamento</h4>
          </div>

          <div
            className="new-colaborator-container"
            style={{ flexDirection: 'column' }}
          >
            <Select2
              dataTestId="comission-select"
              hasAsterisk
              large
              placeholder="Comissões"
              name="comission"
              options={comissoes}
              disabled={comissions && comissions?.length > 2}
              onChange={(e: any) => {
                const repeated = comissions?.find(
                  (item: any) => item.value === e.value
                )
                const noComission = comissions?.find(
                  (item: any) => item.value === 'Sem Comissionamento'
                )
                if (repeated || noComission) return
                if (e.value === 'Sem Comissionamento') {
                  return setComissions([e])
                }
                setComissions((oldValue: any) => [...oldValue, e])
              }}
              searchbar={false}
              value={null}
            />
            <Column>
              {comissions?.map((item: any) => {
                return (
                  <Row>
                    <p className="selected-client-name">{item?.label}</p>
                    <img
                      className="selected-cliente-trash"
                      src={Icon('trash.svg')}
                      alt="trash icon"
                      onClick={() => {
                        setComissions(
                          comissions?.filter(
                            (client: any) => client.value !== item.value
                          )
                        )
                      }}
                    />
                  </Row>
                )
              })}
            </Column>
          </div>
        </div>
        */}
        <div>
          <div className="new-colaborator-subtitle">
            <img
              className="new-colaborator-subtitle-img"
              src={Icon('safety.svg')}
              alt="subtitle icon"
            />
            <h4>Limites de acesso</h4>
          </div>
          <div className="new-colaborator-container-access">
            {levels.map((row) => {
              return (
                <SelectCard
                  data-testid={`level-${row[1]}`}
                  icon={row[0]}
                  value={row[1]}
                  onClick={() => {
                    setData((oldValue: any) => ({
                      ...oldValue,
                      level: data?.level === row[2] ? '' : row[2],
                    }))
                  }}
                  checked={data?.level === row[2]}
                />
              )
            })}
            <ErrorContainer>
              <ErrorText data-testid="level-error" error={levelError}>
                <img
                  className="img-error"
                  src={Icon('alert_circle.svg')}
                  alt="error icon"
                />
                {levelError}
              </ErrorText>
            </ErrorContainer>
          </div>
        </div>
        <div>
          {data.level === `[0, 0, 1, 0, 0, 0, 0, 0, 0]` && (
            <>
              <div
                className="new-colaborator-subtitle"
                style={{ marginTop: 10, marginBottom: 30 }}
              >
                <img
                  className="new-colaborator-subtitle-img"
                  src={Icon('trophy.svg')}
                  alt="subtitle icon"
                />
                <h4>Time comercial que o especialista estará inserido</h4>
              </div>
              <Select2
                hasAsterisk
                large
                dataTestId="client-select"
                placeholder="Gestor"
                name="superiorId"
                options={[...gestSpec, ...gestores]}
                onChange={(e: any) => {
                  setData((oldValue: any) => ({
                    ...oldValue,
                    superiorId: e,
                  }))
                }}
                value={data?.superiorId}
                searchbar={false}
              />
            </>
          )}
        </div>

        <ButtonNext
          isAdvance
          advancePage={() => handleSubmit()}
          isBack={false}
          backPage={() => console.log('back-page')}
        />
      </Form>
    </Container>
  )
}
